<template>
  <div class="list-box fadeIn">
    <div class="list-content">
      <div class="list-box-title">
        <div class="list-title">{{ classInfo?.ClassName }}</div>
      </div>
      <div class="list-rank" :class="{ 'myScore': userScore?.rank > 5 }" :style="{ backgroundColor: theme_color }"
        v-if="userScore">
        <div class="describe">
          <div class="describe-item">
            <div class="describe-top">
              <span>总分</span>
            </div>
            <p class="value">{{ userScore?.Score }}</p>
          </div>
          <div class="describe-item">
            <div class="describe-top">
              <span>完成度</span>
            </div>
            <div class="value">
              <p>{{ userScore?.submitPercent }}</p>
              <p class="percent">%</p>
            </div>
          </div>
          <div class="describe-item">
            <div class="describe-top">
              <span>排名</span>
            </div>
            <p class="value">{{ userScore?.rank }}</p>
          </div>
        </div>
        <div class="ranking-list-box">
          <div class="ranking-name-box">
            <p>排行榜</p>
          </div>
          <div class="ranking-title">
            <p class="title-name">排名</p>
            <p class="title-name" id="title-name">姓名</p>
            <p class="title-name">完成度</p>
            <p class="title-name">得分</p>
            <p class="title-name">徽章数</p>
          </div>
          <div class="ranking-box">
            <div class="ranking-list" v-for="item in stuList"
              :class="{ 'my-background': userScore?.rank == item.rank, 'hide': item.rank > 5 }">
              <p class="ranking-item">{{ item.rank }}</p>
              <p class="ranking-item" id="title-name">{{ item.NickName }}</p>
              <p class="ranking-item">{{ item.submitPercent }}%</p>
              <p class="ranking-item">{{ item.Score }}</p>
              <p class="ranking-item">{{ item.achievement?.length || 0 }}</p>
            </div>
            <div class="ranking-list my-background" v-if="userScore && userScore?.rank > 5">
              <p class="ranking-item">{{ userScore.rank }}</p>
              <p class="ranking-item" id="title-name">{{ userScore.NickName }}</p>
              <p class="ranking-item">{{ userScore.submitPercent }}%</p>
              <p class="ranking-item">{{ userScore.Score }}</p>
              <p class="ranking-item">{{ userScore.achievement?.length || 0 }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="unit-box" :style="{ height: unit_heigth + 'px' }">
      <i class="unit-item" :class="{ finish_unit: item.isFinished, preFinished: item.preFinished }"
        v-for="(item, i) in intList" :style="{ left: item.x + 'px', bottom: item.y + 'px' }" @click="chooseItem(item)"
        @mouseenter="switchBackground(item.Cover)" @mouseleave="switchBackground('')">
        <span class="unit-number">{{ i + 1 }}</span>
        <div class="unit-name" :style="{ backgroundColor: theme_color }">{{ item.InductionName }}</div>
        <div class="unit-progress-box">
          <a-progress class="unit-progress" type="circle" :width="30" :strokeWidth="10" :showInfo="false"
            trailColor="#CCCCCC" strokeColor="#FFFFFF" strokeLinecap="square" :percent="item.submitPercent" />
          <div class="progress-text">{{ item.submitPercent }}%</div>
        </div>
      </i>
    </div>
  </div>
</template>

<script>


export default {
  components: {},
  name: "flag_list",
  props: {
    classInfo: Object,
    userScore: Object,
    intList: Array,
    stuList: Array,
  },
  data() {
    return {
      theme_color: '',
      unit_heigth: 700
    }
  },
  async mounted() {
    let { platform } = this.$store.state;
    this.theme_color = platform.pageConfig.theme_color;

    let that = this;
    this.setUnitHeigth();
    $(window).resize(function () { that.setUnitHeigth() });
  },
  methods: {
    //选择其中一个
    chooseItem(item) {
      if (!item.preFinished && item.preIntName) return this.$message.warning(`请先完成前置单元《${item.preIntName}》，再开始此单元`);
      this.$emit('chooseItem', item)
    },
    //切换背景
    switchBackground(cover) {
      this.$emit('switchBackground', cover )
    },
    //设置高度
    setUnitHeigth() {
      this.unit_heigth = $('.unit-box').width() * (719 / 2000);
      let count = this.intList.length;

      //设置锚点位置
      if (count == 1) {
        this.intList[0].x = ($('.unit-box').width() - 10) * 0.85;
        this.intList[0].y = this.unit_heigth - 20;
        return;
      }

      let widthSpace = ($('.unit-box').width() - 80) * 0.85 / (count - 1);
      let heigthSpace = (this.unit_heigth - 40) / (count - 1);
      this.intList.forEach((item, i) => {
        item.x = widthSpace * i + 80;
        item.y = heigthSpace * i + 25;
      })
    }
  },
  //beforeUnmount() {},
}
</script>

<style scoped lang="scss">
@import "./flag-list.scss";
</style>